import { call, put, select } from "redux-saga/effects";
import {
  getHasDomiciliationSuccess,
  getHasDomiciliationError,
  domiciliationReferenceSuccess,
  domiciliationReferenceError,
} from "../actions/domiciliation";
import { DomiciliationApi } from "../../services/api/DomiciliationApi";
import { getUserInfoSelector } from "../selectors/paymentsSelectors";
import { getDomiciliationValues } from "../selectors/domiciliationSelectors";
import {
  SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS,
  SERVICE_ID_TELCEL_POSPAGO,
} from "../../constants";
import { v4 as uuidv4 } from "uuid";
import { getDomiciliationExpirationDate } from "../../components/organisms/utils";

export function* getHasDomiciliationSaga(action) {
  const { reference, serviceId } = action;
  const { username } = yield select(getUserInfoSelector);
  try {
    const result = yield call(
      DomiciliationApi.getHasDomiciliationService,
      reference,
      username,
      serviceId
    );
    yield put(getHasDomiciliationSuccess(result));
  } catch (error) {
    yield put(getHasDomiciliationError(error));
  }
}

export function* domiciliationReferenceSaga(action) {
  const { encodedPin } = action;
  const {
    username,
    msisdn,
    msisdnEncrypt,
    name,
    secondName,
    fathersName,
    mothersName,
  } = yield select(getUserInfoSelector);

  const { expirationDate, reference, amountValue, tcValue } = yield select(
    getDomiciliationValues
  );
  const calculateExpirationDate = getDomiciliationExpirationDate(expirationDate)
  console.log(calculateExpirationDate, "calculateExpirationDate");

  const dd =  new Date(calculateExpirationDate).getTime()

  const authorizationTyC = tcValue;
  const claroId = username;
  const detail = "Factura Telcel de " + reference;
  const dueDate = 4859740800000; // 01-01-2124
  const expirationDateEpoch = new Date(calculateExpirationDate).getTime() ; // Fecha seleccionada en el form
  const externalId = uuidv4();
  const initialDay = Date.now();
  const maxAmount = parseFloat(amountValue); // Monto seleccionado en el form
  const phoneNumber = msisdn.slice(3, msisdn.length);
  const msisdnCipher = msisdnEncrypt.data;
  const periodicity = SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS.periodicity;
  const pin = encodedPin;
  const productId = null;
  const serviceHolder =
    name + " " + secondName + " " + fathersName + " " + mothersName;
  const serviceId = SERVICE_ID_TELCEL_POSPAGO;

  try {
    const domiciliationCall = yield call(
      DomiciliationApi.domiciliationAccountService,
      authorizationTyC,
      claroId,
      detail,
      dueDate,
      expirationDateEpoch,
      externalId,
      initialDay,
      maxAmount,
      phoneNumber,
      msisdnCipher,
      periodicity,
      pin,
      productId,
      reference,
      serviceHolder,
      serviceId
    );
    yield put(domiciliationReferenceSuccess(domiciliationCall));
  } catch (error) {
    yield put(domiciliationReferenceError(error));
  }
}
